// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget"}[chunkId] + "." + {"231":"e64103c6944d6e35bc9c","263":"56197fbbf90211200805"}[chunkId] + ".js";
};